import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Modal, Button } from "react-bootstrap";
import { Plus, X } from "react-feather";
import { Link } from "react-router-dom";
import testImg from "../../assets/images/samples/test.jpg";

function Penugasan({ lastTicketNumber }) {
  const [orders, setOrders] = useState([]);
  const [selectedArea, setSelectedArea] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  const handleOpenModal = (type, id) => {
    setModalType(type);
    setSelectedId(id);
    setShowModal(true);
  };

  const handleConfirm = () => {
    console.log(`${modalType} tiket:`, selectedId);
    setShowModal(false);
  };

  // === dummy data ===
  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const dateStr = `${yyyy}${mm}${dd}`;

    const dummy = [
      {
        id: 1,
        external_ref: `TGR-${dateStr}-001`,
        description: "Air tidak keluar sejak pagi",
        region_id: "Region-01",
        category: "Teknis",
        tanggal: "2025-09-24 16:55:40",
        priority: "critical",
        status: "new",
        kasie: "Monkey D Luffy",
        photo_url: testImg,
      },
      {
        id: 2,
        external_ref: `TGR-${dateStr}-002`,
        description: "Meter rusak",
        region_id: "Region-02",
        category: "Meteran",
        tanggal: "2025-09-23 11:55:40",
        priority: "high",
        status: "new",
        kasie: "Monkey D Luffy",
        photo_url: testImg,
      },
      {
        id: 3,
        external_ref: `TGR-${dateStr}-003`,
        description: "Tagihan melonjak",
        region_id: "Region-03",
        category: "Administrasi",
        tanggal: "2025-09-22 10:20:40",
        priority: "low",
        status: "new",
        kasie: "Monkey D Luffy",
        photo_url: testImg,
      },
    ];
    setOrders(dummy);
  }, []);

  // === FILTER ===
  const filteredOrders = orders.filter((order) => {
    const matchesArea =
      selectedArea === "all" || order.region_id === selectedArea;
    const matchesSearch =
      order.external_ref.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesArea && matchesSearch;
  });

  // === TABEL COLUMNS ===
  const columns = [
    { name: "No", selector: (row, index) => index + 1, width: "60px" },
    {
      name: "No Tiket",
      selector: (row) => row.external_ref,
      sortable: true,
      minWidth: "180px",
    },
    { name: "Category", selector: (row) => row.category },
    { name: "Wilayah", selector: (row) => row.region_id },
    {
      name: "Keluhan",
      cell: (row) => (
        <div style={{ whiteSpace: "normal", maxWidth: "250px" }}>
          {row.description}
        </div>
      ),
    },
    {
      name: "Priority",
      cell: (row) => {
        let colorClass = "";
        switch (row.priority?.toLowerCase()) {
          case "critical":
            colorClass = "bg-danger";
            break;
          case "high":
            colorClass = "bg-warning text-dark";
            break;
          case "medium":
            colorClass = "bg-primary";
            break;
          case "low":
            colorClass = "bg-success";
            break;
          default:
            colorClass = "bg-secondary";
        }
        return <span className={`badge ${colorClass}`}>{row.priority}</span>;
      },
    },
    { name: "Kasie", selector: (row) => row.kasie },
    { name: "Tanggal", selector: (row) => row.tanggal, minWidth: "180px" },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-1">
          <Link
            to={`/Wo/PenugasanDetail/${row.id}`}
            className="btn btn-sm btn-primary"
          >
            Detail
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="page-title">
        <h3>Manajemen Penugasan (Dummy)</h3>
      </div>

      <section className="section">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">List Penugasan</h4>
            <div className="d-flex gap-2">
              {/* Filter wilayah */}
              <select
                className="form-select form-select-sm"
                value={selectedArea}
                onChange={(e) => setSelectedArea(e.target.value)}
              >
                <option value="all">All Wilayah</option>
                <option value="Region-01">Region-01</option>
                <option value="Region-02">Region-02</option>
                <option value="Region-03">Region-03</option>
              </select>

              {/* Search */}
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Cari tiket..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className="card-body">
            <DataTable
              columns={columns}
              data={filteredOrders}
              pagination
              highlightOnHover
              striped
              responsive
            />
          </div>
        </div>
      </section>

      {/* Modal konfirmasi */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "close"
              ? "Konfirmasi Tutup Tiket"
              : "Konfirmasi Selesai"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === "close"
            ? "Apakah Anda yakin ingin menutup tiket ini?"
            : "Apakah tiket ini sudah selesai dikerjakan?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Batal
          </Button>
          <Button
            variant={modalType === "close" ? "danger" : "success"}
            onClick={handleConfirm}
          >
            {modalType === "close" ? "Tutup Tiket" : "Selesai"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Penugasan;
